export default "__VITE_ASSET__CdfVO754__"